var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_2537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.52394 6.096V3.58686L0.163696 7.11258L4.52394 10.6383V8.18661C4.52955 8.18686 4.53519 8.18698 4.54086 8.18698H11.4894C11.7055 8.18698 11.8808 8.00504 11.8808 7.78127V6.50134C11.8808 6.27727 11.7047 6.09563 11.4894 6.09563H4.54086C4.53519 6.09563 4.52955 6.09575 4.52394 6.096ZM5.82033 4.26812C6.83887 2.04027 9.02427 0.5 11.5559 0.5C15.0609 0.5 17.9022 3.45233 17.9022 7.0942C17.9022 10.7361 15.0609 13.6884 11.5559 13.6884C9.02427 13.6884 6.83887 12.1481 5.82033 9.92029H7.92911C8.75613 11.0643 10.0728 11.8043 11.5559 11.8043C14.0594 11.8043 16.089 9.69555 16.089 7.0942C16.089 4.49286 14.0594 2.38406 11.5559 2.38406C10.0728 2.38406 8.75613 3.12407 7.92911 4.26812H5.82033Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame12);
export default __webpack_public_path__ + "static/media/Frame (12).4da69ce44cbca54de062488e8df15f4e.svg";
export { ForwardRef as ReactComponent };